import React, { useEffect } from 'react';
import { Button, Drawer, Form, Input, Select, Switch, message } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import { useFetch } from 'hooks/useFetch';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

function NewServicesForm({
  isActive,
  onClose,
  onCreate,
  onUpdate,
  initialValues,
}) {
  const [form] = Form.useForm();
  const [urls, loading, error] = useFetch('org/v1/limitAPI/', []);
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (error) {
      message.error('Не удалось загрузить данные (URL services)');
    }
  }, [error]);

  useEffect(() => {
    if (initialValues) {
      const { description, description_kz, isPublic, title, title_kz, urls } =
        initialValues;

      form.setFieldsValue({
        description,
        description_kz,
        isPublic,
        title,
        title_kz,
        urls,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    if (isEditing) {
      onUpdate(values, initialValues?.id);
    } else {
      onCreate(values);
    }

    form.resetFields();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование сервиса' : 'Создание сервиса'}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="title" label="Наименование" rules={[requiredRule]}>
          <Input placeholder="Введите наименование" allowClear />
        </Form.Item>

        <Form.Item
          name="title_kz"
          label="Наименование (каз)"
          rules={[requiredRule]}
        >
          <Input placeholder="Введите наименование" allowClear />
        </Form.Item>

        <Form.Item name="description" label="Описание" rules={[requiredRule]}>
          <Input placeholder="Введите описание" allowClear />
        </Form.Item>

        <Form.Item
          name="description_kz"
          label="Описание (каз)"
          rules={[requiredRule]}
        >
          <Input placeholder="Введите описание" allowClear />
        </Form.Item>

        <Form.Item name="urls" label="URL сервиса (API)">
          <Select
            mode="multiple"
            allowClear
            placeholder="Выбрать url сервиса"
            loading={loading}
            showSearch
            optionFilterProp="children"
            showArrow
          >
            {urls.map(({ id, title }) => (
              <Select.Option key={id} value={id}>
                {title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="isPublic" label="Доступен" valuePropName="checked">
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { NewServicesForm };
